import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { scrollAndFocus } from 'platform/utilities/scroll';
import environment from '~/platform/utilities/environment';
import { ConfirmationView } from 'platform/forms-system/src/js/components/ConfirmationView';

export const ConfirmationPage = props => {
  const form = useSelector(state => state.form || {});
  const submission = form?.submission;
  const submitDate = submission?.timestamp || '';
  const confirmationNumber =
    submission?.response?.attributes?.confirmationNumber || '';
  const claimId = submission?.response?.id;
  const pdfUrl = claimId
    ? `${environment.API_URL}/v0/education_benefits_claims/download_pdf/${claimId}`
    : null;

  const { route } = props;

  useEffect(() => {
    const focusedEl = document.querySelector('va-alert');
    scrollAndFocus(focusedEl);
  }, []);

  return (
    <ConfirmationView
      formConfig={route?.formConfig}
      submitDate={submitDate}
      confirmationNumber={confirmationNumber}
      pdfUrl={pdfUrl}
      devOnly={{
        showButtons: true,
      }}
    >
      <ConfirmationView.SubmissionAlert
        content={
          <p className="vads-u-margin-bottom--0">
            Your submission is in progress.
          </p>
        }
        actions={null}
      />
      <ConfirmationView.SavePdfDownload
        className="vads-u-margin-top--2"
        content="If you’d like a PDF copy of your completed form, you can download it."
      />
      <ConfirmationView.ChapterSectionCollection />
      <ConfirmationView.PrintThisPage />
      <ConfirmationView.WhatsNextProcessList
        item1Header="We’ll review your form"
        item1Content={
          <div>
            <p>
              After you successfully submit your form, we will review your
              documents.
            </p>
            <p>You should hear back within 30 days about your reimbursement.</p>
          </div>
        }
        item1Actions={null}
        item2Header="If you haven’t applied and been found eligible for VA education benefit"
        item2Content={
          <div>
            <p>
              You’ll need to apply and be found eligible for the VA education
              benefit under which you want your reimbursement processed.
            </p>
            <p>
              <va-link
                external
                text="Apply for VA education benefits using Form 22-1990"
                href="https://www.va.gov/education/apply-for-gi-bill-form-22-1990/introduction"
              />
              , <strong>or</strong>
            </p>
            <p>
              <va-link
                external
                text="Apply for VA education benefits as a dependent using Form 22-5490"
                href="https://www.va.gov/family-and-caregiver-benefits/education-and-careers/apply-for-dea-fry-form-22-5490/introduction"
              />
              , <strong>or</strong>
            </p>
            <p>
              <va-link
                external
                text="Apply to use transferred education benefits using Form 22-1990e"
                href="https://www.va.gov/family-and-caregiver-benefits/education-and-careers/transferred-gi-bill-benefits/apply-form-22-1990e/introduction"
              />
            </p>
          </div>
        }
      />
      <ConfirmationView.GoBackLink className="vads-u-margin-bottom--4 vads-u-margin-top--4" />
    </ConfirmationView>
  );
};

ConfirmationPage.propTypes = {
  form: PropTypes.shape({
    data: PropTypes.object,
    formId: PropTypes.string,
    submission: PropTypes.shape({
      timestamp: PropTypes.string,
    }),
  }),
  name: PropTypes.string,
  route: PropTypes.shape({
    formConfig: PropTypes.object,
  }),
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export default ConfirmationPage;
